"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.formatAmountForHeader = exports.adjustAmountForFrontend = exports.adjustAmountForBackend = exports.formatAmountLocaleString = exports.formatAmount = exports.formatAmountForBackend = exports.formatValue = void 0;
const isInteger_1 = __importDefault(require("lodash/isInteger"));
const types_1 = require("./types");
const formatValue = (value) => {
    return value
        .toString()
        .replace(/\B(?=(\d{3})+(?!\d))/g, ' ')
        .replace('.', ',');
};
exports.formatValue = formatValue;
const formatAmountForBackend = (str) => str.replace(',', '.');
exports.formatAmountForBackend = formatAmountForBackend;
const formatAmount = ({ value, currency = '', placeholder = '', }) => value || value === 0
    ? `${(0, exports.formatValue)(value)}${currency && ` ${currency}`}`
    : placeholder;
exports.formatAmount = formatAmount;
const formatAmountLocaleString = ({ value, currency = '', placeholder = '', }) => {
    if (value || value === 0) {
        const formattedValue = (0, isInteger_1.default)(value)
            ? value.toLocaleString(types_1.EToLocaleString.RU)
            : value.toLocaleString(types_1.EToLocaleString.RU, {
                minimumFractionDigits: 2,
                maximumFractionDigits: 2,
            });
        return `${formattedValue}${currency && ` ${currency}`}`;
    }
    else {
        return placeholder;
    }
};
exports.formatAmountLocaleString = formatAmountLocaleString;
const adjustAmountForBackend = (amount) => Math.round(+amount * 100);
exports.adjustAmountForBackend = adjustAmountForBackend;
const adjustAmountForFrontend = (amount) => +amount / 100;
exports.adjustAmountForFrontend = adjustAmountForFrontend;
const formatAmountForHeader = ({ value, currency = '', placeholder = '', }) => value || value === 0
    ? {
        value: (0, exports.formatValue)(value),
        currency,
    }
    : placeholder;
exports.formatAmountForHeader = formatAmountForHeader;
//# sourceMappingURL=index.js.map